<template>
  <div class="container">
        <img src="@/assets/images/img1.png" class="box1">
        <img src="@/assets/images/logo.png" class="box2">
        <img src="@/assets/images/img2.png" class="box3">
        <div class="box4">
          <img src="@/assets/images/img3.png" class="box5">
          <img src="@/assets/images/img4.png" class="box6">
          <img src="@/assets/images/img7.png" class="box9">
        </div>
        <div class="content">
          <div class="box7">
            <img src="@/assets/images/mamcode.jpg" class="mamcode">
          </div>
          <img src="@/assets/images/img6.png" class="box8">
         
        </div>
     

       
       
   
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>

<style scoped  lang="scss">
  .container {
    max-width: 750px;
    width: 100%;
    margin: auto;
    height: 100%;
    background: #f5f4f4;
    overflow-y: auto;
    position: relative;
    .box1 {
      width: 143px;
      position: absolute;
      top: 32px;
      left: 35px;
      z-index: 2;
    }

    .box2 {
      position: absolute;
      top: 23px;
      right: 27px;
      width: 67px;
      z-index: 2;
    }

    .box3 {
      width: 100%;
      margin-top: 60px;
    }
    .box4 {
      position: relative;
      width: 100%;
      margin-top: 34px;
      overflow: hidden;
      .box5 {
        width: 58px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .box6 {
        width: 205px;
        display: block;
        margin: 10px auto 0;
        position: relative;
        z-index: 1;
      }
      .box9 {
        display: block;
       width: 240px;
       margin: -25px auto 0;
      }
    }
    .content {
      width: 100%;
      margin-top: 30px;
      position: relative;
      .box7 {
        background: url("@/assets/images/img5.png") no-repeat;
        background-size: 100%;
        width: 248px;
        height: 248px;
        margin: 0 auto ;
        position: relative;
        z-index: 3;
        overflow: hidden;
        .mamcode {
          display: block;
          width: 220px;
          height: 220px;
          margin:14px auto 0;
        }
      }
      .box8 {
        width: 70px;
        position: absolute;
        right: 0;
        top:200px;
        z-index: 1;
      }
    

    }
    

  
  }
</style>
